interface GridSingleSelect {
  value: string | number;
  label: string;
}

export const RatingSingleSelectOptions: GridSingleSelect[] = [
  { value: 0, label: 'Red' },
  { value: 1, label: 'Blue' },
  { value: 2, label: 'Yellow' },
  { value: 3, label: 'Grey' },
  { value: 4, label: 'Green' },
];
